import { Group } from "@mantine/core";
import { Dispatch } from "react";
import {
  HeldEmailQueueAction,
  HeldEmailQueueState,
} from "../../../hooks/admin/useHeldEmailQueueState";
import { HeldEmailRecipientFilter } from "./HeldEmailRecipientFilter";
import { HeldEmailStateFilter } from "./HeldEmailStateFilter";

interface Props {
  state: HeldEmailQueueState;
  dispatch: Dispatch<HeldEmailQueueAction>;
}

export function HeldEmailQueueFilters({ state, dispatch }: Props) {
  return (
    <Group align="end" grow>
      <HeldEmailRecipientFilter dispatch={dispatch} value={state.recipient} />
      <HeldEmailStateFilter dispatch={dispatch} value={state.states} />
    </Group>
  );
}
